import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import EquationInput from "../../../../components/inputs/EquationInput";
import { parse, simplify } from "mathjs";

// Pomocnicze
function getRandomInt(min, max, excludeZero = false) {
  let num;
  do {
    num = Math.floor(Math.random() * (max - min + 1)) + min;
  } while (excludeZero && num === 0);
  return num;
}

// Generowanie zadania
export function generateTask() {
  const a = getRandomInt(-5, 5, true); // bez zera
  const b = getRandomInt(-10, 10);
  const answer = simplifyExpression("", a, b);

  return {
    type: "ComputeNextTermLinearTask",
    data: { a, b },
    answer,
  };
}

// Treść zadania
export function renderTask({ data }) {
  const { a, b } = data;
  const aTerm = `${a === 1 ? '' : a === -1 ? '-' : a}n ${b === 0 ? '' : b < 0 ? `- ${-b}` : `+ ${b}`}`;
  return (
    <div className="space-y-2">
      <p>Dany jest ciąg określony wzorem:</p>
      <BlockMath math={`a_n = ${aTerm}`} />
      <p>Wyznacz wzór wyrazu <InlineMath math="a_{n+1}" />.</p>
    </div>
  );
}

// Input
export function renderInput({ data }, userAnswer, onChange, disabled) {
return (
  <div className="space-y-2">
<EquationInput
  value={userAnswer || ""}
  onChange={onChange}
  disabled={disabled}
  placeholder="np. 4n + 1"
  showPreview={false}
/>
    {userAnswer && userAnswer.trim() !== "" && (
      <div>
        <strong>Podgląd:</strong>{" "}
        <InlineMath math={`a_{n+1} = ${userAnswer}`} />
      </div>
    )}
  </div>
);

}

// Poprawna odpowiedź
export function renderAnswer({ answer }) {
  return <InlineMath math={`a_{n+1} = ${answer}`} />;
}

// Porównanie


export function checkAnswer({ answer }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "string") {
    return { isCorrect: false };
  }

  try {
    const parsedUser = simplify(parse(userAnswer));
    const parsedExpected = simplify(parse(answer));

    const testValues = [1, 2, 3, 5, 7];
    const isEquivalent = testValues.every(n => {
      const scope = { n };
      const userVal = parsedUser.evaluate(scope);
      const expectedVal = parsedExpected.evaluate(scope);
      return Math.abs(userVal - expectedVal) < 1e-9;
    });

    const isExactForm = parsedUser.toString() === parsedExpected.toString();

    if (isEquivalent) {
      if (isExactForm) {
        return true;
      } else {
        return {
          correct: true,
          needsSimplification: true,
          expected: `a_{n+1} = ${answer}`
        };
      }
    }

    return false;
  } catch (e) {
    return { isCorrect: false };
  }
}



// Wyjaśnienie
export function renderExplanation({ data, answer }) {
  const { a, b } = data;

  const expanded = `${a}n ${a < 0 ? '-' : '+'} ${Math.abs(a)}`;
  const reduced = `${a}n ${a + b < 0 ? '-' : '+'} ${Math.abs(a + b)}`;

  const fullStart = `${a}(n + 1) ${b < 0 ? `- ${-b}` : `+ ${b}`}`;

  return (
    <div className="space-y-4" style={{ textAlign: "left" }}>
      <div>
        <strong>Krok 1:</strong> Podstawiamy do wzoru:
        <BlockMath math={`a_{n+1} = ${fullStart}`} />
      </div>
      <div>
        <strong>Krok 2:</strong> Mnożymy nawias:
        <BlockMath math={`a_{n+1} = ${expanded} ${b < 0 ? `- ${-b}` : `+ ${b}`}`} />
      </div>
      <div>
        <strong>Krok 3:</strong> Redukujemy wyrazy wolne:
        <BlockMath math={`a_{n+1} = ${reduced}`} />
      </div>
    </div>
  );
}


// Odpowiedź użytkownika
export function renderUserAnswer(userAnswer, task) {
  if (!userAnswer || typeof userAnswer !== "string" || userAnswer.trim() === "") {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`a_{n+1} = ${userAnswer}`} />;
}


function simplifyExpression(expr, a, b) {
  const linear = `${a}n`;
  const constant = a + b;
  const sign = constant < 0 ? "-" : "+";
  return `${linear} ${sign} ${Math.abs(constant)}`;
}

